import * as React from "react";

import {Tab} from '../../Elements/Tabs';
import { getMain, SettingToPolicyMap } from "./tabDefinition";
import {DeviceHardwareEnum, isGx8} from "../DeviceHardwareEnum";
import { checkPermissionsForCustomer } from "../Policy/rightsUtil";
import { GlobalRoles } from "../GlobalRoles";
import { Device } from "./types";
import { SettingEnum } from "./settingEnum";
import { Route } from "react-router-dom";
import { AllPermissions, PolicyContext } from "@Safemate/Policy/Provider";
import { PolicyNameEnum } from "@Safemate/PolicyNameEnum";
import LocalLearning from "./Sensor/Add/localLearning";
import { SensorDetails } from "./Sensor/sensorDetails";
import {Capabilities} from "@Safemate/Settings/Store/types";
import { EditFunction } from "./Sensor/Actions/editFunction";


export const SettingAllowGlobalRoles = [GlobalRoles.SUPERFIRM, GlobalRoles.FIRM, GlobalRoles.RESTRICTED_USER];
export const SettingAllowCustomerGlobalRoles = [GlobalRoles.SUPERFIRM, GlobalRoles.FIRM];

type MapTabs = ( dehaId: DeviceHardwareEnum, formatMessage: Function, isAhp: boolean, isPrivate: boolean, device: Device, permissions: Map<PolicyNameEnum, AllPermissions>, capabilities: Map<number, Capabilities>) => JSX.Element[];

export const mapTabs: MapTabs = ( dehaId, formatMessage, isAhp, isPrivate, device, permissions, capabilities) => {

  const comps = getMain(dehaId, device, !!device.lastMsgIn, isAhp, isPrivate, capabilities);
  
  const entries = comps.entries();
  let result = entries.next();
  const tabs: JSX.Element[] = [];


  while(!result.done){
    const [ menu, comp ] = result.value;
    const policyToCheck = SettingToPolicyMap.get(menu);
    if(policyToCheck && checkPermissionsForCustomer(permissions, policyToCheck, device.ownedByCustomer))
      tabs.push(
        <Tab name={menu} title={formatMessage({id: menu, defaultMessage: menu})}>
          {comp}
        </Tab>
      )
    result = entries.next();
  }
  return tabs;
}

type MapAdditionalRoutes = (dehaId: DeviceHardwareEnum, isAhp: boolean, isPrivate: boolean, beta: boolean, device: Device, baseUrl: string, capabilities: Map<number, Capabilities>) => JSX.Element[]

export const mapAdditionalRoutes: MapAdditionalRoutes = (dehaId, isAhp, isPrivate, beta, device, baseUrl, capabilities) => {

  const comps = getMain(dehaId, device, !!device.lastMsgIn, isAhp, isPrivate, capabilities);

  if(comps.has(SettingEnum.SENSOR)){
    return [
      <Route exact path={`${baseUrl}/add`}>
        <LocalLearning returnPath={`${baseUrl}/sensor`}/>
      </Route>,
      <Route exact path={`${baseUrl}/config/sensor/:id`}>
        <EditFunction returnPath={`${baseUrl}/sensor`}/>
      </Route>,
      <Route exact path={`${baseUrl}/info/sensor/:id`}>
        <SensorDetails returnPath={`${baseUrl}/sensor`}/>
      </Route>,
    ]
  }
  return []
}
